// Screen `onboarding` — design/screens/Onboarding.dc.html — owner: S9.
import { z } from 'zod';
import { createFileRoute } from '@tanstack/react-router';
import { OnboardingPage } from '../../features/onboarding/OnboardingPage';

export const Route = createFileRoute('/_focus/onboarding')({
  validateSearch: z.object({ blueprint: z.string().max(120).optional() }),
  component: OnboardingPage,
});
